import * as React from 'react';

function SvgLogoMessengerOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 25" }, props),
        React.createElement("path", { fill: "currentColor", d: "M11.998 2C6.476 2 2 6.145 2 11.26c0 2.913 1.454 5.512 3.726 7.21V22l3.404-1.869a10.74 10.74 0 002.868.387c5.522 0 9.999-4.145 9.999-9.259C21.997 6.145 17.52 2 11.998 2zm.994 12.47l-2.546-2.717-4.968 2.716 5.465-5.802 2.608 2.716 4.906-2.716-5.465 5.802z" })));
}

export default SvgLogoMessengerOutline;
